<script setup>
import { ref } from 'vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  label: { type: String, required: true },
  // When given, the value becomes a trigger for a DropdownMenu with these items.
  menuItems: { type: Array, default: null },
  // Keeps the menu open after a pick, for lists the user toggles several items of.
  multiple: { type: Boolean, default: false },
});

const emit = defineEmits(['select']);

const isOpen = ref(false);

const onAction = item => {
  emit('select', item);
  if (!props.multiple) isOpen.value = false;
};
</script>

<template>
  <div class="grid grid-cols-[7rem_1fr] items-center gap-2 min-h-8">
    <span class="text-sm text-n-slate-11">{{ label }}</span>
    <div v-on-clickaway="() => (isOpen = false)" class="relative min-w-0">
      <button
        v-if="menuItems"
        type="button"
        class="flex items-center w-full min-w-0 gap-2 px-1.5 -mx-1.5 text-sm text-left rounded-md min-h-7 text-n-slate-12 hover:bg-n-alpha-2"
        @click="isOpen = !isOpen"
      >
        <slot />
      </button>
      <div
        v-else
        class="flex items-center min-w-0 gap-2 text-sm text-n-slate-12"
      >
        <slot />
      </div>
      <!-- Opens inward from the value's far edge, so the narrow side panel never scrolls
           sideways to fit it. -->
      <DropdownMenu
        v-if="isOpen"
        :menu-items="menuItems"
        class="z-50 w-56 mt-1 top-full ltr:right-0 rtl:left-0"
        @action="onAction"
      />
    </div>
  </div>
</template>
